import Vue from 'vue'
import Router from 'vue-router'

import LoggingIn from '@/modules/LoggingIn'
// import TandC from '@/modules/TandC'
import Admin from '@/modules/Admin'
import AdminOld from '@/modules/AdminOld'
import store from '@/store'
import jwtDecode from 'jwt-decode'

import UserRegistration from '@/modules/UserRegistration'
import SelfRegistration from '@/modules/SelfRegistration'
import ResetPassword from '@/modules/ResetPassword'
import MyProfile from '@/modules/MyProfile'
import Login from '@/modules/Login'
import ErrorComp from '@/modules/Error'
// import app from '@/helpers/app';
import TokenManager from '@/modules/TokenManager'
import TokenManagerOld from '@/modules/TokenManagerOld'
import APISettings from '@/modules/APISettings'
import APISettingsOld from '@/modules/APISettingsOld'
import SystemLogs from '@/modules/SystemLogs'
import Reports from '@/modules/Reports'
// import okta from '@/helpers/okta'
import Auth, { LoginCallback } from "@okta/okta-vue"
import { OktaAuth } from '@okta/okta-auth-js'
import storage from '@/helpers/storage'
import oktaConfigs from '../helpers/okta-config'

// const orgUrl = process.env.ORG_URL;
// var keyID = process.env.KEY_ID;
// let redirectUrl = window.location.protocol + "//" + window.location.hostname +
// (window.location.port ? ':' + window.location.port : '') + '/login/callback';
let config = oktaConfigs.getConfig();
const oktaAuth = new OktaAuth({
  issuer: config.issuer,
  clientId: config.clientId,
  redirectUri: config.redirectUrl,
  scopes: config.scopes,
  pkce: config.pkce
})

Vue.use(Router)
Vue.use(Auth, { oktaAuth })

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/Error',
      name: 'Error',
      component: ErrorComp
    },
    {
      path: '/LoggingIn',
      name: 'LoggingIn',
      component: LoggingIn
    },
    {
      path: '/Admin',
      name: 'Admin',
      component: Admin,
      meta: {
        requiresAuthentication: true
      }
    },
    {
      path: '/AdminOld',
      name: 'adminold',
      component: AdminOld,
      meta: {
        requiresAuthentication: true
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '*',
      redirect: '/Admin',
      component: Admin
    },
    {
      path: '/UserRegistration',
      name: 'UserRegistration',
      component: UserRegistration
    },
    {
      path: '/SelfRegistration',
      name: 'SelfRegistration',
      component: SelfRegistration
    },
    {
      path: '/ResetPassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/MyProfile',
      name: 'MyProfile',
      component: MyProfile,
      meta: {
        requiresAuthentication: true
      }
    },
    {
      path: '/TokenManager',
      name: 'TokenManager',
      component: TokenManager,
      meta: {
        requiresAuthentication: true
      }
    },
    {
      path: '/TokenManagerOld',
      name: 'TokenManagerOld',
      component: TokenManagerOld,
      meta: {
        requiresAuthentication: true
      }
    },
    {
      path: '/UnlockAccount',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/APISettings',
      name: 'APISettings',
      component: APISettings,
      meta: {
        requiresAuthentication: true
      }
    },
    {
      path: '/APISettingsOld',
      name: 'APISettingsOld',
      component: APISettingsOld,
      meta: {
        requiresAuthentication: true
      }
    },
    {
      path: '/SystemLogs',
      name: 'SystemLogs',
      component: SystemLogs,
      meta: {
        requiresAuthentication: true
      }
    },
    {
      path: '/login/callback',
      name: 'Callback',
      component: LoginCallback
    },
    {
      path: '/Reports',
      name: 'Reports',
      component: Reports,
      meta: {
        requiresAuthentication: true
      }
    }
  ]
})

router.beforeEach(async (from, to, next) => {
  var userRole = storage.get('cf-userRole')
  var isAuth = await Vue.prototype.$auth.isAuthenticated()
  if (from.matched.some((record) => record.meta.requiresAuthentication) && !isAuth) {
    next({ path: "Login" });
  } else {
    if (from.hash.indexOf('id_token') > -1) {
      // okta.addToTokenManager('id_token', to.hash.split('&')[0].split('=')[1])
      // okta.addToTokenManager('access_token', to.hash.split('&')[1].split('=')[1])
      storage.set('id_token', from.hash.split('&')[0].split('=')[1])
      storage.set('access_token', from.hash.split('&')[1].split('=')[1])
      store.commit('setUser', jwtDecode(from.hash.split('&')[0].split('=')[1]))
    }
    if (to.fullPath.indexOf('rd=') !== -1) {
      let redirectUrl = (to.fullPath).split("%2Fhome%2F");
      redirectUrl = decodeURIComponent(redirectUrl[1]);
      window.location.href = process.env.ORG_URL + 'home/' + redirectUrl;
    } else if (from.name.toLowerCase() === 'admin' && (userRole === 'notadmin' || userRole === undefined)) {
      // User Role 4 is not allowed to go to the Admin page, so redirect them to the Home page
      next({replace: true, name: 'MyProfile'});
    } else if ((from.name.toLowerCase() === 'adminold' || from.name.toLowerCase() === 'tokenmanager' || from.name.toLowerCase() === 'tokenmanagerold' || from.name.toLowerCase() === 'apisettings' || from.name.toLowerCase() === 'apisettingsold' || from.name.toLowerCase() === 'systemlogs') && (userRole === 'admin' || userRole === 'notadmin' || userRole === undefined)) {
      // User Role 4 is not allowed to go to the Admin page, so redirect them to the Home page
      next({replace: true, name: 'MyProfile'});
    } else {
      next();
    }
  }
})

// router.beforeEach(onAuthRequired);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js